export default "__VITE_ASSET__qXlU4pKI__"